import { render } from "./PresentationSlideFour.vue?vue&type=template&id=7cc00ac4&scoped=true"
import script from "./PresentationSlideFour.vue?vue&type=script&lang=js"
export * from "./PresentationSlideFour.vue?vue&type=script&lang=js"

import "./PresentationSlideFour.vue?vue&type=style&index=0&id=7cc00ac4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc00ac4"]])

export default __exports__